import React from "react";
export default function UserIcon({ className = '' }) {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "50",
        height: "50",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className
    }, /*#__PURE__*/ React.createElement("path", {
        opacity: "0.21",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 30V37C0 49.7025 10.2975 60 23 60H30H37C49.7025 60 60 49.7025 60 37V30V23C60 10.2975 49.7025 0 37 0H30H23C10.2975 0 0 10.2975 0 23V30Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: "0.587821",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.666 23.3333C20.666 26.2789 23.0538 28.6667 25.9993 28.6667C28.9449 28.6667 31.3327 26.2789 31.3327 23.3333C31.3327 20.3878 28.9449 18 25.9993 18C23.0538 18 20.666 20.3878 20.666 23.3333ZM33.9993 28.6667C33.9993 30.8758 35.7902 32.6667 37.9993 32.6667C40.2085 32.6667 41.9993 30.8758 41.9993 28.6667C41.9993 26.4575 40.2085 24.6667 37.9993 24.6667C35.7902 24.6667 33.9993 26.4575 33.9993 28.6667Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.9778 31.333C19.6826 31.333 14.5177 34.5684 14.0009 40.9319C13.9727 41.2786 14.6356 41.9997 14.97 41.9997H36.9956C37.9972 41.9997 38.0128 41.1936 37.9972 40.933C37.6065 34.3906 32.3616 31.333 25.9778 31.333ZM45.2746 41.9997L40.1333 41.9997C40.1333 38.9984 39.1417 36.2288 37.4683 34.0005C42.0103 34.0501 45.7189 36.3465 45.998 41.1997C46.0092 41.3951 45.998 41.9997 45.2746 41.9997Z",
        fill: "currentColor"
    }));
}
